<form [formGroup]="loginForm" class="container-fluid pt-5">
    <div class="row justify-content-center align-items-center mx-auto mt-5">
      <div class="col-lg-4 col-md-6 col-sm-12 mt-5">
        <div class="card border-warning shadow-sm">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <h4 class="card-title text-center mb-3">
                  <img style="height: 50px;" src="assets/YellowFolderHNT.svg" alt="">
                </h4>
              </div>
            </div>
            <div class="form-group mt-2">
              <input type="email" class="form-control form-control-sm" name="email" placeholder="Email"
                formControlName="email" />
            </div>
            <div class="form-group mt-2">
              <input type="password" class="form-control form-control-sm" name="password" placeholder="Password" required
                formControlName="password"/>
            </div>
            <button type="submit" class="btn btn-warning btn-sm bt mt-2 float-end" (click)="login()">
              Login 
              <span>
                <span *ngIf="!isLoading"><i class="fa-regular fa-angles-right"></i></span>
                <span *ngIf="isLoading"><i class="fas fa-circle-notch fa-spin"></i></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>